import React from "react";
import { Callout, FormGroup, Alert, Intent, Button } from "@blueprintjs/core";
import styles from "./BankAccount.module.scss";
import { Icon } from "../../../atoms/Icon";
import FormInfo from "../../../atoms/FormInfo/FormInfo";

function BankAccountCard({
  isBankAdded,
  removeAlertOpen,
  setRemoveAlertOpen,
  addAccount,
  setAddAccount,
  removeExistingAccount,
  bank
}) {
  return (
    <div className={styles.bankShortInfo}>
      <FormGroup label="Bank Account">
        <FormInfo>
          Please provide links to the following. These links will be shown at
          checkout, on the receipts that the customer receives, and in your
          profile.
        </FormInfo>
      </FormGroup>

      <Callout className={styles.bankBox}>
        <div className={styles.flexBox}>
          <div className={styles.bankIconDiv}>
            <Icon
              name="Bank"
              size={21}
              color="#9fa9ba"
              className={styles.bankIcon}
            />
          </div>
          <div className={styles.bankText}>
            <div className={styles.bankName}>{bank.name}</div>
            <div className={styles.bankAccountNumber}>
              {" "}
              ●●●●●●●●{bank.digits}
            </div>
          </div>
        </div>
      </Callout>

      {!addAccount && isBankAdded && (
        <>
          <Alert
            cancelButtonText="Cancel"
            confirmButtonText="Remove Account"
            icon="trash"
            intent={Intent.DANGER}
            isOpen={removeAlertOpen}
            onCancel={() => setRemoveAlertOpen(false)}
            onConfirm={removeExistingAccount}
          >
            <p>
              Are you sure you want to remove your bank account information from
              <b> Video Squirrel</b>? You won’t be able to cash out or top off
              your balance until you add another account.
            </p>
          </Alert>

          <Button
            onClick={() => {
              setAddAccount(true);
            }}
            disabled={addAccount}
            className={styles.btnUpdateAccount}
            text="Update Account"
            intent={Intent.PRIMARY}
          />
          <Button
            onClick={() => {
              setRemoveAlertOpen(true);
            }}
            intent={Intent.DANGER}
            text="Remove Account"
          />
        </>
      )}
    </div>
  );
}

export default BankAccountCard;
